export const characters = [
  {
    id: "naruto",
    name: "漩涡鸣人",
    nameJp: "うずまきナルト",
    epithet: "吊车尾忍者 · 第七代火影",
    category: "主角",
    village: "火之国 · 木叶隐村",
    rank: "上忍 / 火影",
    ninjaType: "风遁 · 影分身 · 九尾查克拉",
    avatar:
      "https://readdy.ai/api/search-image?query=Stylized%20anime%20cel%20shaded%20portrait%20of%20a%20cheerful%20young%20male%20ninja%20with%20short%20spiky%20blond%20hair%2C%20whisker%20marks%20on%20both%20cheeks%2C%20bright%20blue%20eyes%2C%20wearing%20an%20orange%20and%20black%20jacket%20with%20a%20metal%20forehead%20protector%2C%20confident%20grin%2C%20head%20and%20shoulders%20view%2C%20simple%20clean%20warm%20orange%20gradient%20background%2C%20consistent%20art%20style%2C%20high%20detail%2C%20vibrant%20colors&width=700&height=700&seq=char-naruto-avatar&orientation=squarish",
    intro:
      "体内封印着九尾妖狐的少年，从小被村民排斥却从不放弃，立志成为受全村认可的火影。",
    bio: [
      "鸣人出生时，九尾妖狐被封印在他体内，因此自幼遭受村民的疏远与冷眼。孤独的童年没有击垮他，反而让他更渴望被认可，他把「成为火影」当作唯一的执念。",
      "在伊鲁卡老师的关怀下，鸣人第一次感受到被接纳的温暖。此后他凭借不服输的毅力，从忍者学校的吊车尾一步步成长，掌握了影分身、螺旋丸与仙人模式等强大忍术。",
      "经过与佐助的羁绊与离别、与晓组织的生死对抗，鸣人逐渐从被孤立的少年成长为能守护所有人的忍者。最终他实现了梦想，成为第七代火影。",
    ],
    abilities: [
      { name: "多重影分身之术", desc: "制造出大量实体分身协同作战，是鸣人最标志性的忍术。" },
      { name: "螺旋丸", desc: "自来也传授的A级忍术，将查克拉高速旋转压缩成球体造成破坏。" },
      { name: "仙人模式", desc: "吸收自然能量强化自身，大幅提升感知与攻击威力。" },
      { name: "九尾查克拉模式", desc: "与九尾和解后借用尾兽之力，获得惊人的速度与恢复力。" },
    ],
    relations: ["sasuke", "sakura", "kakashi", "jiraiya"],
    tags: ["九尾人柱力", "螺旋丸", "仙人模式", "第七代火影"],
  },
  {
    id: "sasuke",
    name: "宇智波佐助",
    nameJp: "うちはサスケ",
    epithet: "复仇的写轮眼 · 宇智波末裔",
    category: "主角",
    village: "火之国 · 木叶隐村（后离村）",
    rank: "上忍",
    ninjaType: "火遁 · 雷遁 · 写轮眼",
    avatar:
      "https://readdy.ai/api/search-image?query=Stylized%20anime%20cel%20shaded%20portrait%20of%20a%20cool%20young%20male%20ninja%20with%20black%20spiky%20hair%20framing%20his%20face%2C%20dark%20eyes%2C%20wearing%20a%20high%20collar%20dark%20shirt%20and%20a%20forehead%20protector%2C%20serious%20expression%2C%20head%20and%20shoulders%20view%2C%20simple%20clean%20cool%20grey%20gradient%20background%2C%20consistent%20art%20style%2C%20high%20detail%2C%20vibrant%20colors&width=700&height=700&seq=char-sasuke-avatar&orientation=squarish",
    intro:
      "宇智波一族的幸存者，为向兄长复仇而不断变强，冷酷外表下藏着对家族与羁绊的挣扎。",
    bio: [
      "童年时，佐助亲眼目睹宇智波一族被兄长宇智波鼬灭门，复仇从此成为他活着的唯一意义。他天赋出众，被视为同届的第一名。",
      "为了获得更强的力量，佐助选择离开木叶追随大蛇丸。他与鸣人在终结之谷展开宿命对决，斩断羁绊却始终无法真正放下。",
      "在得知灭门真相后，佐助的仇恨几经辗转，最终选择以自己的方式守护木叶与哥哥留下的意志，成为暗中守护村子的「影中之影」。",
    ],
    abilities: [
      { name: "写轮眼 / 万花筒写轮眼", desc: "宇智波一族的血继限界，可复制忍术、看破幻术并施展强力瞳术。" },
      { name: "千鸟 / 雷切", desc: "卡卡西传授的雷遁绝技，将雷电集中于手中高速突刺。" },
      { name: "天照", desc: "万花筒写轮眼瞳术，释放无法熄灭的黑色火焰。" },
      { name: "须佐能乎", desc: "以瞳力具现化的巨大查克拉武者，拥有极强的攻防能力。" },
    ],
    relations: ["naruto", "itachi", "sakura", "kakashi"],
    tags: ["写轮眼", "千鸟", "须佐能乎", "宇智波一族"],
  },
  {
    id: "sakura",
    name: "春野樱",
    nameJp: "春野サクラ",
    epithet: "怪力医疗忍者 · 第五代火影亲传",
    category: "主角",
    village: "火之国 · 木叶隐村",
    rank: "上忍",
    ninjaType: "医疗忍术 · 怪力 · 百豪之术",
    avatar:
      "https://readdy.ai/api/search-image?query=Stylized%20anime%20cel%20shaded%20portrait%20of%20a%20determined%20young%20female%20ninja%20with%20shoulder%20length%20pink%20hair%20and%20green%20eyes%2C%20wearing%20a%20red%20top%20with%20a%20forehead%20protector%2C%20fighting%20spirit%2C%20head%20and%20shoulders%20view%2C%20simple%20clean%20soft%20pink%20gradient%20background%2C%20consistent%20art%20style%2C%20high%20detail%2C%20vibrant%20colors&width=700&height=700&seq=char-sakura-avatar&orientation=squarish",
    intro:
      "队伍中的医疗与头脑担当，拜纲手为师后掌握怪力与高超医疗忍术，是无可替代的后援。",
    bio: [
      "樱起初是队伍中战斗经验最浅的成员，但她拥有过人的查克拉操控天赋与扎实的理论基础。",
      "为不再成为同伴的负担，她主动拜五代火影纲手为师，习得怪力与医疗忍术，成长为能独当一面的忍者。",
      "在战场上，樱多次以精准的医疗术挽救同伴生命，同时以惊人的怪力正面迎敌，展现出真正的强大。",
    ],
    abilities: [
      { name: "怪力", desc: "将查克拉集中于拳脚，释放出粉碎岩石的恐怖打击力。" },
      { name: "医疗忍术", desc: "以精细查克拉操控治愈伤口，被誉为新生代最出色的医疗忍者。" },
      { name: "百豪之术", desc: "长期储存查克拉，在一定时间内获得近乎不死的自愈能力。" },
      { name: "樱花冲", desc: "集中查克拉的强力拳击，可瞬间击碎地面制造冲击波。" },
    ],
    relations: ["naruto", "sasuke", "tsunade", "kakashi"],
    tags: ["怪力", "医疗忍术", "百豪之术"],
  },
  {
    id: "kakashi",
    name: "旗木卡卡西",
    nameJp: "はたけカカシ",
    epithet: "拷贝忍者 · 第七班指导上忍",
    category: "主角",
    village: "火之国 · 木叶隐村",
    rank: "上忍 / 第六代火影",
    ninjaType: "雷遁 · 写轮眼 · 万花筒",
    avatar:
      "https://readdy.ai/api/search-image?query=Stylized%20anime%20cel%20shaded%20portrait%20of%20a%20calm%20male%20ninja%20with%20silver%20spiky%20hair%2C%20a%20dark%20mask%20covering%20the%20lower%20face%2C%20one%20eye%20hidden%20under%20a%20slanted%20forehead%20protector%2C%20wearing%20a%20dark%20green%20vest%2C%20relaxed%20pose%2C%20head%20and%20shoulders%20view%2C%20simple%20clean%20warm%20grey%20gradient%20background%2C%20consistent%20art%20style%2C%20high%20detail&width=700&height=700&seq=char-kakashi-avatar&orientation=squarish",
    intro:
      "木叶的精英上忍，第七班老师，冷静从容、经验丰富，被誉为「拷贝忍者卡卡西」。",
    bio: [
      "卡卡西是木叶白牙之子，自幼便展现出惊人的天赋，同时也是带土的挚友与琳的同伴。",
      "他继承了带土赠予的写轮眼，因此能复制上千种忍术，被世人称为「拷贝忍者」。",
      "作为老师，他善于激发学生的潜力，用「抛弃同伴的人，比废物还不如」的信念影响了一代忍者。",
    ],
    abilities: [
      { name: "雷切", desc: "以雷遁查克拉强化手掌高速突刺，传说能劈开雷电。" },
      { name: "写轮眼 · 复制", desc: "借写轮眼复制对手忍术，被称为拷贝忍者。" },
      { name: "神威", desc: "万花筒写轮眼瞳术，可将目标传送至异空间。" },
      { name: "影分身之术", desc: "以查克拉制造实体分身，常用于侦察与实战。" },
    ],
    relations: ["naruto", "sasuke", "sakura"],
    tags: ["拷贝忍者", "雷切", "神威", "第六代火影"],
  },
  {
    id: "orochimaru",
    name: "大蛇丸",
    nameJp: "おろちまる",
    epithet: "三忍之一 · 追求永恒的白蛇",
    category: "反派",
    village: "火之国 · 木叶隐村（叛忍）",
    rank: "S级叛忍",
    ninjaType: "蛇系忍术 · 禁术 · 秽土转生",
    avatar:
      "https://readdy.ai/api/search-image?query=Stylized%20anime%20cel%20shaded%20portrait%20of%20a%20sinister%20pale%20male%20ninja%20with%20long%20straight%20black%20hair%2C%20snake%20like%20golden%20eyes%20with%20purple%20markings%2C%20wearing%20a%20dark%20robe%20with%20a%20rope%20belt%2C%20eerie%20smile%2C%20head%20and%20shoulders%20view%2C%20simple%20clean%20dark%20green%20gradient%20background%2C%20consistent%20art%20style%2C%20high%20detail&width=700&height=700&seq=char-orochimaru-avatar&orientation=squarish",
    intro:
      "传说中的三忍之一，痴迷于永生与一切忍术，是佐助离村后依靠的危险导师。",
    bio: [
      "大蛇丸曾是木叶的天才忍者，与自来也、纲手并称三忍。对母亲之死的悲痛让他执着于追寻永生。",
      "他进行大量禁术与活体实验，被视为S级叛忍，并暗中建立音忍村作为自己的据点。",
      "他觊觎佐助的身体与写轮眼，但最终在佐助的反击与鼬的封印下失去力量，之后成为亦正亦邪的旁观者。",
    ],
    abilities: [
      { name: "秽土转生", desc: "将亡者灵魂召回现世并操控，是禁术中的禁术。" },
      { name: "八岐大蛇之术", desc: "召唤巨大蛇形查克拉实体，展现其蛇系本源。" },
      { name: "软体改造", desc: "通过改造获得异常柔韧的身体，可躲避致命攻击。" },
      { name: "不尸转生", desc: "将自身意识转移至他人身体以实现变相永生。" },
    ],
    relations: ["sasuke", "itachi", "jiraiya", "tsunade"],
    tags: ["三忍", "禁术", "音忍村", "S级叛忍"],
  },
  {
    id: "itachi",
    name: "宇智波鼬",
    nameJp: "うちはイタチ",
    epithet: "背负骂名的守护者 · 晓成员",
    category: "反派",
    village: "火之国 · 木叶隐村（叛忍）",
    rank: "S级叛忍",
    ninjaType: "月读 · 天照 · 须佐能乎",
    avatar:
      "https://readdy.ai/api/search-image?query=Stylized%20anime%20cel%20shaded%20portrait%20of%20a%20stoic%20male%20ninja%20with%20long%20black%20hair%20tied%20back%2C%20red%20patterned%20eyes%2C%20deep%20lines%20under%20his%20eyes%2C%20wearing%20a%20black%20cloak%20with%20red%20clouds%2C%20stern%20calm%20expression%2C%20head%20and%20shoulders%20view%2C%20simple%20clean%20deep%20crimson%20gradient%20background%2C%20consistent%20art%20style%2C%20high%20detail&width=700&height=700&seq=char-itachi-avatar&orientation=squarish",
    intro:
      "宇智波的天才，为守护村子与弟弟背负灭族之名，真相揭开后成为最令人心碎的角色。",
    bio: [
      "鼬自幼便拥有超越年龄的洞察力，他意识到宇智波一族的叛乱将导致村子毁灭，从而走向无法回头的深渊。",
      "他独自背负灭族之罪，加入晓组织充当间谍，用最沉重的代价换取和平与弟弟的生路。",
      "在生命走到尽头时，鼬微笑著对佐助说出最后一句话，将守护的意志留给了弟弟，成为无数观众心中的意难平。",
    ],
    abilities: [
      { name: "月读", desc: "万花筒写轮眼瞳术，在瞬间将对手拖入无尽的幻术世界。" },
      { name: "天照", desc: "以视线点燃无法熄灭的黑色火焰。" },
      { name: "须佐能乎", desc: "具现化的查克拉武者，持神器攻守兼备。" },
      { name: "乌鸦分身", desc: "以乌鸦为媒介的幻术与分身技巧。" },
    ],
    relations: ["sasuke", "orochimaru", "pain"],
    tags: ["万花筒写轮眼", "月读", "天照", "晓"],
  },
  {
    id: "pain",
    name: "佩恩（长门）",
    nameJp: "長門",
    epithet: "晓的首领 · 轮回眼持有者",
    category: "反派",
    village: "雨之国 · 雨隐村",
    rank: "S级叛忍",
    ninjaType: "轮回眼 · 六道佩恩 · 神罗天征",
    avatar:
      "https://readdy.ai/api/search-image?query=Stylized%20anime%20cel%20shaded%20portrait%20of%20a%20mysterious%20male%20ninja%20with%20orange%20spiky%20hair%2C%20multiple%20metallic%20piercings%20on%20his%20face%2C%20ringed%20purple%20eyes%2C%20wearing%20a%20black%20cloak%20with%20red%20clouds%2C%20cold%20gaze%2C%20head%20and%20shoulders%20view%2C%20simple%20clean%20dark%20charcoal%20gradient%20background%2C%20consistent%20art%20style%2C%20high%20detail&width=700&height=700&seq=char-pain-avatar&orientation=squarish",
    intro:
      "晓的明面首领，以「让世界感受痛苦」为信条，企图用绝对力量终结纷争。",
    bio: [
      "长门出生在战乱的雨之国，自幼目睹战争带来的失去，渴望以真正的力量带来和平。",
      "他操控六具尸体组成的「六道佩恩」发动袭击，用压倒性实力摧毁木叶，逼问鸣人的答案。",
      "在与鸣人的对话中，他被那份不放弃的信念打动，选择以自己的生命复活木叶的死者，诠释了痛苦与理解的另一种可能。",
    ],
    abilities: [
      { name: "轮回眼", desc: "传说中六道仙人拥有的瞳术，可施展六道之力。" },
      { name: "神罗天征", desc: "以自身为中心释放巨大斥力，瞬间摧毁大片区域。" },
      { name: "万象天引", desc: "以引力将目标强行拉近，配合攻击难以闪避。" },
      { name: "六道佩恩", desc: "以六具尸体分工操控，覆盖战斗、感知与复活等多种能力。" },
    ],
    relations: ["naruto", "itachi", "jiraiya"],
    tags: ["轮回眼", "晓", "六道佩恩", "雨隐村"],
  },
  {
    id: "gaara",
    name: "我爱罗",
    nameJp: "我愛羅",
    epithet: "砂瀑的我爱罗 · 第五代风影",
    category: "次要角色",
    village: "风之国 · 砂隐村",
    rank: "影（风影）",
    ninjaType: "砂遁 · 一尾守鹤",
    avatar:
      "https://readdy.ai/api/search-image?query=Stylized%20anime%20cel%20shaded%20portrait%20of%20a%20pale%20young%20male%20ninja%20with%20short%20red%20hair%2C%20dark%20rings%20around%20his%20eyes%2C%20a%20red%20mark%20on%20his%20forehead%2C%20wearing%20a%20sand%20colored%20outfit%20and%20gourd%2C%20stoic%20calm%20expression%2C%20head%20and%20shoulders%20view%2C%20simple%20clean%20warm%20sand%20gradient%20background%2C%20consistent%20art%20style%2C%20high%20detail&width=700&height=700&seq=char-gaara-avatar&orientation=squarish",
    intro:
      "曾被恐惧孤立的砂隐人柱力，在鸣人的影响下学会被爱，最终成为守护村子的风影。",
    bio: [
      "我爱罗自幼体内封印着一尾守鹤，因失控伤害他人而被村民恐惧与疏远，童年充满孤独。",
      "在中忍考试与鸣人的交锋中，他第一次理解了被认可与被爱的意义，内心开始发生转变。",
      "此后他肩负起风影之责，以沉稳与担当守护砂隐村，成为木叶最可靠的盟友之一。",
    ],
    abilities: [
      { name: "砂之护盾", desc: "由母亲意志化成的自动砂盾，几乎能防御一切攻击。" },
      { name: "砂瀑送葬", desc: "以巨量砂流压制并碾压对手的强力忍术。" },
      { name: "砂之化身", desc: "将身体与砂融合，用于防御与转移。" },
      { name: "守鹤之力", desc: "一尾守鹤的尾兽查克拉，赋予其强大防御与砂操控力。" },
    ],
    relations: ["naruto", "shikamaru"],
    tags: ["风影", "砂遁", "一尾人柱力"],
  },
  {
    id: "jiraiya",
    name: "自来也",
    nameJp: "自来也",
    epithet: "蛤蟆仙人 · 传说中的三忍",
    category: "次要角色",
    village: "火之国 · 木叶隐村",
    rank: "上忍",
    ninjaType: "仙人模式 · 蛤蟆召唤 · 螺旋丸",
    avatar:
      "https://readdy.ai/api/search-image?query=Stylized%20anime%20cel%20shaded%20portrait%20of%20a%20burly%20male%20ninja%20with%20long%20spiky%20white%20hair%20and%20two%20red%20marks%20under%20his%20eyes%2C%20wearing%20a%20green%20and%20red%20outfit%20with%20a%20large%20scroll%2C%20bold%20grin%2C%20head%20and%20shoulders%20view%2C%20simple%20clean%20warm%20green%20gradient%20background%2C%20consistent%20art%20style%2C%20high%20detail&width=700&height=700&seq=char-jiraiya-avatar&orientation=squarish",
    intro:
      "鸣人的恩师，自由不羁的蛤蟆仙人，用一生寻找和平的答案，也把信念传给了弟子。",
    bio: [
      "自来也是传说中的三忍之一，游历各国搜集情报，同时以作家身份写下畅销小说。",
      "他收鸣人为徒，教导其查克拉控制与螺旋丸，是鸣人成长路上最重要的引路人。",
      "在独自潜入雨隐村调查晓组织时，他留下最后的暗号，将关于和平与预言之子的信念托付给未来。",
    ],
    abilities: [
      { name: "仙人模式", desc: "与蛤蟆深度契约后进入仙人模式，感知与忍术威力大幅提升。" },
      { name: "螺旋丸", desc: "自来也改良并传授给鸣人的招牌忍术。" },
      { name: "蛤蟆召唤", desc: "召唤蛤蟆文太等强大伙伴协同作战。" },
      { name: "乱狮子发之术", desc: "以硬化长发束缚并攻击对手。" },
    ],
    relations: ["naruto", "tsunade", "orochimaru", "pain"],
    tags: ["三忍", "仙人模式", "蛤蟆仙人"],
  },
  {
    id: "tsunade",
    name: "纲手",
    nameJp: "綱手",
    epithet: "传说中的女忍者 · 第五代火影",
    category: "次要角色",
    village: "火之国 · 木叶隐村",
    rank: "影（火影）",
    ninjaType: "怪力 · 医疗忍术 · 蛞蝓召唤",
    avatar:
      "https://readdy.ai/api/search-image?query=Stylized%20anime%20cel%20shaded%20portrait%20of%20a%20confident%20female%20ninja%20with%20long%20blonde%20hair%20tied%20in%20two%20ponytails%2C%20a%20small%20green%20gem%20on%20her%20forehead%2C%20wearing%20a%20green%20haori%20over%20a%20grey%20outfit%2C%20commanding%20expression%2C%20head%20and%20shoulders%20view%2C%20simple%20clean%20soft%20gold%20gradient%20background%2C%20consistent%20art%20style%2C%20high%20detail&width=700&height=700&seq=char-tsunade-avatar&orientation=squarish",
    intro:
      "三忍中唯一的女性，被誉为最强医疗忍者，重掌木叶成为第五代火影。",
    bio: [
      "纲手出身名门，是初代火影千手柱间的孙女，因失去挚爱而一度对火影之名心存芥蒂。",
      "在鸣人的坚持与自来也的劝说下，她重新燃起守护村子的决心，就任第五代火影。",
      "她以强大的医疗忍术与领导力，带领木叶度过一次又一次危机，是村子最坚实的支柱。",
    ],
    abilities: [
      { name: "怪力", desc: "精准控制查克拉释放，拳脚之力可粉碎城墙。" },
      { name: "创造再生", desc: "解放百豪之术储存的查克拉，获得超强自愈。" },
      { name: "医疗忍术", desc: "被誉为最强医疗忍者，能治愈绝大多数重伤。" },
      { name: "蛞蝓召唤", desc: "召唤活蝓进行大范围治疗与支援。" },
    ],
    relations: ["sakura", "jiraiya", "orochimaru", "naruto"],
    tags: ["三忍", "第五代火影", "医疗忍术"],
  },
  {
    id: "hinata",
    name: "日向雏田",
    nameJp: "日向ヒナタ",
    epithet: "日向宗家之女 · 柔拳传承者",
    category: "次要角色",
    village: "火之国 · 木叶隐村",
    rank: "中忍 / 上忍",
    ninjaType: "白眼 · 柔拳",
    avatar:
      "https://readdy.ai/api/search-image?query=Stylized%20anime%20cel%20shaded%20portrait%20of%20a%20gentle%20young%20female%20ninja%20with%20long%20dark%20purple%20hair%2C%20pale%20lavender%20pupilless%20eyes%2C%20wearing%20a%20cream%20colored%20hooded%20jacket%2C%20shy%20warm%20smile%2C%20head%20and%20shoulders%20view%2C%20simple%20clean%20soft%20lavender%20gradient%20background%2C%20consistent%20art%20style%2C%20high%20detail&width=700&height=700&seq=char-hinata-avatar&orientation=squarish",
    intro:
      "日向宗家的长女，性格温和却内心坚定，从鸣人身上获得勇气并不断突破自我。",
    bio: [
      "雏田出身日向宗家，拥有白眼血继限界，但童年因性格柔弱而被父亲否定。",
      "鸣人永不放弃的身影一直激励着她，让她逐渐鼓起勇气，走出属于自己的忍道。",
      "她以柔拳与白眼在战场上守护同伴，用行动证明了内向者同样可以拥有惊人的坚韧。",
    ],
    abilities: [
      { name: "白眼", desc: "日向一族血继限界，可看穿对手经脉与查克拉流动。" },
      { name: "柔拳", desc: "以掌击直接作用于对手经络，封锁查克拉流动。" },
      { name: "八卦六十四掌", desc: "在近身范围内连续封住对手多处经络的柔拳绝技。" },
      { name: "双狮拳", desc: "以双手化作狮首形态的进阶柔拳攻击。" },
    ],
    relations: ["naruto", "shikamaru"],
    tags: ["白眼", "柔拳", "日向一族"],
  },
  {
    id: "shikamaru",
    name: "奈良鹿丸",
    nameJp: "奈良シカマル",
    epithet: "怕麻烦的军师 · 木叶的头脑",
    category: "次要角色",
    village: "火之国 · 木叶隐村",
    rank: "上忍 / 顾问",
    ninjaType: "影子束缚术",
    avatar:
      "https://readdy.ai/api/search-image?query=Stylized%20anime%20cel%20shaded%20portrait%20of%20a%20lazy%20young%20male%20ninja%20with%20dark%20hair%20tied%20in%20a%20high%20spiky%20ponytail%2C%20narrow%20brown%20eyes%2C%20wearing%20a%20dark%20green%20flak%20jacket%2C%20bored%20calm%20expression%2C%20head%20and%20shoulders%20view%2C%20simple%20clean%20warm%20olive%20gradient%20background%2C%20consistent%20art%20style%2C%20high%20detail&width=700&height=700&seq=char-shikamaru-avatar&orientation=squarish",
    intro:
      "智商超过两百的天才军师，虽总把「麻烦」挂在嘴边，却总在关键时刻力挽狂澜。",
    bio: [
      "鹿丸表面上懒散怕麻烦，实则拥有惊人的战术头脑，是同期忍者中最冷静的分析者。",
      "他善于利用地形与影子束缚术布置陷阱，常在人数劣势下扭转战局。",
      "在同伴牺牲后，他真正明白了责任的分量，成长为能独当一面的可靠忍者与木叶的智囊。",
    ],
    abilities: [
      { name: "影子束缚术", desc: "以影子束缚对手行动，是奈良一族传承秘术。" },
      { name: "影缝", desc: "将影子化作锋利针状贯穿对手的进阶术式。" },
      { name: "战术分析", desc: "超高智商带来的临场谋划与全局掌控能力。" },
      { name: "查克拉刀", desc: "配合影子术使用的近身战斗手段。" },
    ],
    relations: ["naruto", "gaara", "hinata"],
    tags: ["影子束缚术", "军师", "奈良一族"],
  },
];